import { updateGameplayCount } from "../API/progress";

export const startNewGameplay = async (userId) => {
  const current = parseInt(sessionStorage.getItem("gameplay_number") || "1", 10);
  const next = current + 1;

  // Preserve current session state (optional, if needed for debugging or history)
  const failedCastles = sessionStorage.getItem("failed_castles") || "[]";
  const currentPoints = sessionStorage.getItem(`points_${userId}`) || "0";

  sessionStorage.setItem(`failed_castles_gameplay_${current}`, failedCastles);
  sessionStorage.setItem(`points_gameplay_${current}`, currentPoints);

  // Start new session
  sessionStorage.setItem("gameplay_number", next.toString());
  sessionStorage.setItem("failed_castles", "[]");
  sessionStorage.setItem(`points_${userId}`, "0");
  sessionStorage.setItem("game_completed", "false");
  sessionStorage.setItem("allow_replay_conquered", "true");

  // ✅ Reset newly conquered castles for this session
  sessionStorage.setItem("newly_conquered_castles", "[]");

  console.log("🔁 Starting new gameplay:", next);

  // ✅ Update gameplay count in backend
  try {
    const res = await updateGameplayCount(userId, next);
    if (!res.success) {
      console.error("❌ Failed to update gameplay count on server:", res.message);
    } else {
      console.log("✅ Gameplay count updated on server to:", next);
    }
  } catch (error) {
    console.error("❌ Error during updateGameplayCount call:", error);
  }
};
